import { itemMedia } from 'utils/itemMedia';

export const getRequestPayload = (
  language,
  limit,
  skip,
  selectedItem,
  query,
  erpSystem,
) => {
  let payload = {
    erpSystem,
    language,
    limit,
    skip,
    query,
  };
  const stemExtensionAttrVal = selectedItem?.attributes.find(
    attr => attr.attributeIdentifier === 'EGTF_6035__STRING',
  )?.value;
  let filter = { basicForm: 'stem_extension' };
  const assemblyParams = {
    attributes: { EGTF_6035__STRING: stemExtensionAttrVal },
  };
  return { ...payload, filter: filter, assemblyParams: assemblyParams };
};

export const transformStemExtensionData = (stemExtensionData, price, stock) => {
  return {
    items: [
      {
        description: stemExtensionData.description,
        partNumber: stemExtensionData.partNumber,
        brand: stemExtensionData.brand,
        erpPartNumber: stemExtensionData.erpPartNumber,
        descriptionMap: stemExtensionData.descriptionMap,
        configuration: stemExtensionData.configuration,
        image: itemMedia(stemExtensionData.medias, [
          'product image 01',
          'product image 02',
          'item image',
        ])[0],
        quantityMeasure: stemExtensionData.quantityMeasure,
        price: price.data.items[0],
        stockStatus: stock.data.items[0],
      },
    ],
  };
};
